import { IAttachmentType } from "../model/AttachmentType";
import AttachmentTypeMapper from "../service/AttachmentTypeMapper";
import UpdateResourceInteractor from "../../core/interactor/app/crud/UpdateResourceInteractor";
import Constants from "../../organisations/common/Constants";
import AttachmentTypeParamMapper from "../service/AttachmentTypeParamMapper";

export default class UpdateAttachmentTypeInteractor {
  private resource: UpdateResourceInteractor<IAttachmentType>;

  constructor({ updateResource }: any) {
    this.resource = updateResource;
  }

  async execute(model: IAttachmentType) {
    const result = await this.resource.execute(
      Constants.attachmentTypePath,
      AttachmentTypeMapper,
      AttachmentTypeParamMapper,
      model,
      model.id
    );

    return result;
  }
}
